import { KeyboardDatePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';
import { nanoid } from 'nanoid';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormElement } from 'components/Form';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from './DatePickerStyles';
const idSuffix = nanoid();
export default function DatePicker({
  onChange,
  useUtc,
  customClass
}) {
  const {
    t,
    i18n
  } = useTranslation();
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const {
    datePickerRoot,
    item,
    customRoot
  } = useStyles();
  const mask = isNorwegian(i18n) ? '__.__.____' : '__/__/____';
  const onDatesChange = ({
    startDate,
    endDate
  }) => {
    const formattedStartOfDay = useUtc ? startDate ? dayjs.utc(startDate.startOf('day').format('YYYY-MM-DD')) : null : startDate?.startOf('day') || null;
    const formattedEndOfDay = useUtc ? endDate ? dayjs.utc(endDate.startOf('day').format('YYYY-MM-DD')).endOf('day') : null : endDate?.endOf('day') || null;
    onChange({
      startDate: formattedStartOfDay,
      endDate: formattedEndOfDay
    });
  };
  useEffect(() => {
    onDatesChange({
      startDate: start,
      endDate: end
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, end]);
  const startDateId = `startDate_${idSuffix}`;
  const endDateId = `endDate_${idSuffix}`;
  return /*#__PURE__*/React.createElement("div", {
    className: customClass ? customRoot : datePickerRoot
  }, /*#__PURE__*/React.createElement(FormElement, {
    title: t('datepicker.start_date'),
    childId: startDateId
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    mask: mask,
    clearable: true,
    value: start,
    onChange: date => setStart(date),
    inputVariant: "outlined",
    format: "L",
    className: item,
    placeholder: t('datepicker.start_date'),
    clearLabel: t('datepicker.dialog.clear'),
    cancelLabel: t('datepicker.dialog.cancel'),
    InputProps: {
      inputProps: {
        id: startDateId
      }
    }
  })), /*#__PURE__*/React.createElement(FormElement, {
    title: t('datepicker.end_date'),
    childId: endDateId
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    mask: mask,
    clearable: true,
    value: end,
    onChange: date => setEnd(date),
    inputVariant: "outlined",
    format: "L",
    className: item,
    placeholder: t('datepicker.end_date'),
    clearLabel: t('datepicker.dialog.clear'),
    cancelLabel: t('datepicker.dialog.cancel'),
    InputProps: {
      inputProps: {
        id: endDateId
      }
    }
  })));
}
DatePicker.defaultProps = {
  customClass: false
};